/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import {
    REQUEST_VERSION_INFO,
    RECEIVE_VERSION_INFO
} from './VersionActions'

const initialState = {
    build: {
        version: '',
    },
    loading: false,
}

export const version = (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_VERSION_INFO:
            return {
                ...state,
                loading: true,
            }
        case RECEIVE_VERSION_INFO:
            return {
                ...state,
                loading: false,
                build: {
                    ...state.build,
                    ...action.build.build,
                },
            }
        default:
            return state
    }
}